import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-24 ss-alinhar-desktop-direita-mobile-centro" }
const _hoisted_3 = { class: "ant-btn-group" }
const _hoisted_4 = { class: "ant-btn ant-btn-secondary ss-botoes-icones" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "ss-alinhar-centro" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Teclas de Atalho - Grade de Itens")
], -1)
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_8 = {
  key: 0,
  class: "acoes-item"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 9,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  class: "acoes-item",
  style: {"margin-top":"2px"}
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_selecionar_produto_movimento = _resolveComponent("selecionar-produto-movimento")!
  const _component_selecionar_unidade_produto_movimento = _resolveComponent("selecionar-unidade-produto-movimento")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_selecionar_estoque_produto_movimento = _resolveComponent("selecionar-estoque-produto-movimento")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_nota_fiscal_item_modal = _resolveComponent("nota-fiscal-item-modal")!
  const _component_detalhes_produto_modal = _resolveComponent("detalhes-produto-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.props.editavel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_a_tooltip, {
                title: "Adicionar Novo Item",
                placement: "left"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    class: "ant-btn ant-btn-secondary ss-acao-destaque-secundaria",
                    style: {"margin-top":"4px"},
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.adicionarItemGrade && _ctx.adicionarItemGrade(...args)))
                  }, "Inserir item")
                ]),
                _: 1
              }),
              _createVNode(_component_a_dropdown, null, {
                overlay: _withCtx(() => [
                  _createVNode(_component_a_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tag, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Shift + N")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Adicionar novo Item ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tag, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Shift + E")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Editar detalhes do produto ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tag, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Shift + DEL")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Deletar um item ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tag, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Shift + TAB")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Campo anterior ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tag, null, {
                            default: _withCtx(() => [
                              _createTextVNode("TAB")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Próximo campo ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tag, null, {
                            default: _withCtx(() => [
                              _createTextVNode("↑")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Campo acima ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tag, null, {
                            default: _withCtx(() => [
                              _createTextVNode("↓")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Campo abaixo ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_a_tooltip, {
                    title: "Teclas de Atalho",
                    placement: "left"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", _hoisted_4, [
                        _createVNode(_component_icone, {
                          style: {"margin-top":"2px"},
                          nome: "ajuda"
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(), _createBlock(_component_a_table, {
          key: _ctx.props.chaveItens,
          loading: _ctx.props.carregando,
          columns: _ctx.state.colunasGrade.filter(item => item.visible),
          "data-source": _ctx.props.itens,
          rowKey: "codigo",
          pagination: false,
          size: "small",
          rowClassName: "ss-table-campos",
          bordered: ""
        }, {
          emptyText: _withCtx(() => [
            _createVNode(_component_mensagem_sem_dados, { mensagem: "Nenhum item adicionado ainda" })
          ]),
          bodyCell: _withCtx(({ column, record, index }) => [
            (column.key === 'acoes')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("a", {
                    class: "visualizar",
                    title: "Editar/Visualizar",
                    onClick: ($event: any) => (_ctx.editarItem(index))
                  }, [
                    _createVNode(_component_icone, { nome: "editar" })
                  ], 8, _hoisted_9),
                  _createElementVNode("a", {
                    class: "visualizar",
                    title: "Detalhes do Produto",
                    onClick: ($event: any) => (_ctx.exibirDetalhesProduto(index))
                  }, [
                    _createVNode(_component_icone, { nome: "informacoes-fp" })
                  ], 8, _hoisted_10),
                  (_ctx.props.editavel)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "excluir",
                        onClick: ($event: any) => (_ctx.excluirItem(index))
                      }, [
                        _createVNode(_component_icone, { nome: "excluir" })
                      ], 8, _hoisted_11))
                    : _createCommentVNode("", true)
                ]))
              : (column.key === 'Produto')
                ? (_openBlock(), _createBlock(_component_selecionar_produto_movimento, {
                    key: 1,
                    classCss: "hidden ss-campo-selecao-table ss-nota-fiscal-eletronica-itens",
                    classGroupCss: "ss-campo-selecao-table",
                    title: column.title,
                    dataAttributeColuna: column.key,
                    empresas: [_ctx.dadosEmpresa.codigoEmpresa],
                    codigoSelecionado: record.codigoProdutoDefinicao,
                    "onUpdate:codigoSelecionado": ($event: any) => ((record.codigoProdutoDefinicao) = $event),
                    descricao: record.descricao,
                    "onUpdate:descricao": ($event: any) => ((record.descricao) = $event),
                    codigoUnidadePrincipal: record.codigoUnidadePrincipal,
                    "onUpdate:codigoUnidadePrincipal": ($event: any) => ((record.codigoUnidadePrincipal) = $event),
                    fatorUnidadePrincipal: record.fatorUnidadePrincipal,
                    "onUpdate:fatorUnidadePrincipal": ($event: any) => ((record.fatorUnidadePrincipal) = $event),
                    codigoInterno: record.codigoProduto,
                    "onUpdate:codigoInterno": ($event: any) => ((record.codigoProduto) = $event),
                    codigoBarras: record.codigoBarras,
                    "onUpdate:codigoBarras": ($event: any) => ((record.codigoBarras) = $event),
                    origemMercadoria: record.impostos.origemMercadoria,
                    "onUpdate:origemMercadoria": ($event: any) => ((record.impostos.origemMercadoria) = $event),
                    codigoNcm: record.impostos.codigoNcm,
                    "onUpdate:codigoNcm": ($event: any) => ((record.impostos.codigoNcm) = $event),
                    ncm: record.impostos.ncm,
                    "onUpdate:ncm": ($event: any) => ((record.impostos.ncm) = $event),
                    emDigitacao: record.emDigitacao,
                    "onUpdate:emDigitacao": ($event: any) => ((record.emDigitacao) = $event),
                    buscarDadosAtualizados: _ctx.props.atualizarValores,
                    disabled: !_ctx.props.editavel,
                    limparSelecao: false,
                    onChange: ($event: any) => (_ctx.obterDadosFiscaisProduto(index)),
                    onValorDigitado: ($event: any) => (_ctx.salvarItemGrade(index, record)),
                    onKeydown: [
                      _withKeys(_withModifiers(($event: any) => (_ctx.exibirDetalhesProduto(index)), ["shift","exact","prevent"]), ["d"]),
                      _withKeys(_withModifiers(($event: any) => (_ctx.editarItem(index)), ["shift","exact","prevent"]), ["e"]),
                      _withKeys(_withModifiers(($event: any) => (_ctx.excluirItem(index, $event)), ["shift","exact","prevent"]), ["delete"]),
                      _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["tab"])),
                      _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                      _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent","shift"]), ["tab"])),
                      _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoEsquerda(record.emDigitacao, $event)), ["prevent"]), ["left"]),
                      _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoDireita(record.emDigitacao, $event)), ["prevent"]), ["right"]),
                      _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoAbaixo(record.emDigitacao, $event, column.key)), ["prevent"]), ["down"]),
                      _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoAcima(record.emDigitacao, $event, column.key)), ["prevent"]), ["up"])
                    ]
                  }, null, 8, ["title", "dataAttributeColuna", "empresas", "codigoSelecionado", "onUpdate:codigoSelecionado", "descricao", "onUpdate:descricao", "codigoUnidadePrincipal", "onUpdate:codigoUnidadePrincipal", "fatorUnidadePrincipal", "onUpdate:fatorUnidadePrincipal", "codigoInterno", "onUpdate:codigoInterno", "codigoBarras", "onUpdate:codigoBarras", "origemMercadoria", "onUpdate:origemMercadoria", "codigoNcm", "onUpdate:codigoNcm", "ncm", "onUpdate:ncm", "emDigitacao", "onUpdate:emDigitacao", "buscarDadosAtualizados", "disabled", "onChange", "onValorDigitado", "onKeydown"]))
                : (column.key === 'Unidade')
                  ? (_openBlock(), _createBlock(_component_selecionar_unidade_produto_movimento, {
                      classCss: "hidden ss-campo-selecao-table ss-nota-fiscal-eletronica-itens",
                      classGroupCss: "ss-campo-selecao-table",
                      apenasUnidadePrincipal: false,
                      dataAttributeColuna: column.key,
                      title: record.descricaoUnidade,
                      codigoProdutoDefinicao: record.codigoProdutoDefinicao,
                      editavel: _ctx.props.editavel,
                      codigoUnidadeSelecionada: record.codigoUnidade,
                      "onUpdate:codigoUnidadeSelecionada": ($event: any) => ((record.codigoUnidade) = $event),
                      descricao: record.descricaoUnidade,
                      "onUpdate:descricao": ($event: any) => ((record.descricaoUnidade) = $event),
                      sigla: record.siglaUnidade,
                      "onUpdate:sigla": ($event: any) => ((record.siglaUnidade) = $event),
                      fracionar: record.fracionarUnidade,
                      "onUpdate:fracionar": ($event: any) => ((record.fracionarUnidade) = $event),
                      casasDecimais: record.casasDecimaisUnidade,
                      "onUpdate:casasDecimais": ($event: any) => ((record.casasDecimaisUnidade) = $event),
                      fatorConversao: record.fatorConversao,
                      "onUpdate:fatorConversao": ($event: any) => ((record.fatorConversao) = $event),
                      percentualFormacaoPreco: record.percentualFormacaoPreco,
                      "onUpdate:percentualFormacaoPreco": ($event: any) => ((record.percentualFormacaoPreco) = $event),
                      apresentarApenasSigla: true,
                      disabled: (!_ctx.props.editavel || (record.codigoProdutoDefinicao === 0)),
                      key: ('UNIDADE' + record.codigoProdutoDefinicao + _ctx.props.chaveItens + index),
                      buscarDadosAtualizados: _ctx.props.atualizarValores,
                      onChange: ($event: any) => (_ctx.alterarUnidade(index)),
                      onValorDigitado: ($event: any) => (_ctx.salvarItemGrade(index, record)),
                      onKeydown: [
                        _withKeys(_withModifiers(($event: any) => (_ctx.exibirDetalhesProduto(index)), ["shift","exact","prevent"]), ["d"]),
                        _withKeys(_withModifiers(($event: any) => (_ctx.editarItem(index)), ["shift","exact","prevent"]), ["e"]),
                        _withKeys(_withModifiers(($event: any) => (_ctx.excluirItem(index, $event)), ["shift","exact","prevent"]), ["delete"]),
                        _cache[4] || (_cache[4] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["tab"])),
                        _cache[5] || (_cache[5] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                        _cache[6] || (_cache[6] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent","shift"]), ["tab"])),
                        _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoEsquerda(record.emDigitacao, $event)), ["prevent"]), ["left"]),
                        _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoDireita(record.emDigitacao, $event)), ["prevent"]), ["right"]),
                        _withKeys(_withModifiers(($event: any) => (_ctx.elementoAbaixo($event, column.key)), ["prevent"]), ["down"]),
                        _withKeys(_withModifiers(($event: any) => (_ctx.elementoAcima($event, column.key)), ["prevent"]), ["up"])
                      ]
                    }, null, 8, ["dataAttributeColuna", "title", "codigoProdutoDefinicao", "editavel", "codigoUnidadeSelecionada", "onUpdate:codigoUnidadeSelecionada", "descricao", "onUpdate:descricao", "sigla", "onUpdate:sigla", "fracionar", "onUpdate:fracionar", "casasDecimais", "onUpdate:casasDecimais", "fatorConversao", "onUpdate:fatorConversao", "percentualFormacaoPreco", "onUpdate:percentualFormacaoPreco", "disabled", "buscarDadosAtualizados", "onChange", "onValorDigitado", "onKeydown"]))
                  : (column.key === 'Quantidade')
                    ? _withDirectives((_openBlock(), _createBlock(_component_selecionar_estoque_produto_movimento, {
                        empresas: [_ctx.dadosEmpresa.codigoEmpresa],
                        codigoProdutoDefinicao: record.codigoProdutoDefinicao,
                        movimentarSaida: (_ctx.props.tipoOperacao === _ctx.ETipoOperacao.Saida),
                        movimentarEntrada: (_ctx.props.tipoOperacao === _ctx.ETipoOperacao.Entrada),
                        codigoUnidadePrincipal: record.codigoUnidadePrincipal,
                        fatorConversaoUnidadePrincipal: record.fatorConversaoUnidadePrincipal,
                        codigoUnidadeSelecionada: record.codigoUnidade,
                        fatorConversaoUnidadeSelecionada: record.fatorConversao,
                        quantidade: record.quantidade,
                        "onUpdate:quantidade": ($event: any) => ((record.quantidade) = $event),
                        itensEstoque: record.estoques,
                        "onUpdate:itensEstoque": ($event: any) => ((record.estoques) = $event),
                        classCss: "ss-nota-fiscal-eletronica-itens",
                        processando: _ctx.computedCarregando,
                        "onUpdate:processando": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.computedCarregando) = $event)),
                        disabled: !_ctx.props.editavel,
                        index: index,
                        apresentarEstoques: (_ctx.state.apresentarEstoquesItem && _ctx.state.indexDetalhesEstoques === index),
                        popOverHover: _ctx.state.popOverHoverEstoqueItem,
                        "onUpdate:popOverHover": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.popOverHoverEstoqueItem) = $event)),
                        inputFocus: _ctx.state.inputFocusEstoqueItem,
                        "onUpdate:inputFocus": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.inputFocusEstoqueItem) = $event)),
                        estoquesMovimento: record.estoquesMovimento,
                        "onUpdate:estoquesMovimento": ($event: any) => ((record.estoquesMovimento) = $event),
                        identificacaoElemento: ('QTDE' + record.codigoProdutoDefinicao + _ctx.props.chaveItens + index),
                        key: ('SEL-QTDE' + record.codigoProdutoDefinicao + _ctx.props.chaveItens + index),
                        onBlur: _ctx.quantidadeBlur,
                        onValorDigitado: ($event: any) => (_ctx.salvarItemGrade(index, record))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createBlock(_component_campo_numerico, {
                            dataAttributeColuna0: column.key,
                            title: column.title,
                            classCss: "hidden ss-campo-numero-table ss-nota-fiscal-eletronica-itens",
                            classGroupCss: "hidden ss-campo-numero-table ant-input",
                            valor: record.quantidade,
                            "onUpdate:valor": ($event: any) => ((record.quantidade) = $event),
                            emDigitacao: record.emDigitacao,
                            "onUpdate:emDigitacao": ($event: any) => ((record.emDigitacao) = $event),
                            quantidadeCasasDecimais: record.casasDecimaisUnidade,
                            disabled: !_ctx.props.editavel,
                            key: ('QTDE' + record.codigoProdutoDefinicao + _ctx.props.chaveItens + index),
                            onFocus: ($event: any) => (_ctx.quantidadeFoco(index)),
                            onBlur: _ctx.quantidadeBlur,
                            onValorDigitado: ($event: any) => (_ctx.salvarItemGrade(index, record)),
                            onKeydown: [
                              _withKeys(_withModifiers(($event: any) => (_ctx.exibirDetalhesProduto(index)), ["shift","exact","prevent"]), ["d"]),
                              _withKeys(_withModifiers(($event: any) => (_ctx.editarItem(index)), ["shift","exact","prevent"]), ["e"]),
                              _withKeys(_withModifiers(($event: any) => (_ctx.excluirItem(index, $event)), ["shift","exact","prevent"]), ["delete"]),
                              _cache[7] || (_cache[7] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["tab"])),
                              _cache[8] || (_cache[8] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                              _cache[9] || (_cache[9] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent","shift"]), ["tab"])),
                              _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoEsquerda(record.emDigitacao, $event)), ["prevent"]), ["left"]),
                              _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoDireita(record.emDigitacao, $event)), ["prevent"]), ["right"]),
                              _withKeys(_withModifiers(($event: any) => (_ctx.elementoAbaixo($event, column.key)), ["prevent"]), ["down"]),
                              _withKeys(_withModifiers(($event: any) => (_ctx.elementoAcima($event, column.key)), ["prevent"]), ["up"])
                            ]
                          }, null, 8, ["dataAttributeColuna0", "title", "valor", "onUpdate:valor", "emDigitacao", "onUpdate:emDigitacao", "quantidadeCasasDecimais", "disabled", "onFocus", "onBlur", "onValorDigitado", "onKeydown"]))
                        ]),
                        _: 2
                      }, 1032, ["empresas", "codigoProdutoDefinicao", "movimentarSaida", "movimentarEntrada", "codigoUnidadePrincipal", "fatorConversaoUnidadePrincipal", "codigoUnidadeSelecionada", "fatorConversaoUnidadeSelecionada", "quantidade", "onUpdate:quantidade", "itensEstoque", "onUpdate:itensEstoque", "processando", "disabled", "index", "apresentarEstoques", "popOverHover", "inputFocus", "estoquesMovimento", "onUpdate:estoquesMovimento", "identificacaoElemento", "onBlur", "onValorDigitado"])), [
                        [_vShow, (record.codigoProdutoDefinicao > 0)]
                      ])
                    : (column.key === 'ValorUnitario')
                      ? (_openBlock(), _createBlock(_component_campo_numerico, {
                          dataAttributeColuna: column.key,
                          title: column.title,
                          monetario: true,
                          classGroupCss: "hidden ss-campo-numero-table",
                          classCss: "hidden ss-campo-numero-table ss-nota-fiscal-eletronica-itens",
                          valor: record.precoUnitario,
                          "onUpdate:valor": ($event: any) => ((record.precoUnitario) = $event),
                          emDigitacao: record.emDigitacao,
                          "onUpdate:emDigitacao": ($event: any) => ((record.emDigitacao) = $event),
                          disabled: !_ctx.props.editavel,
                          quantidadeCasasDecimais: record.casasDecimaisPrecoUnitario,
                          key: ('VUNIT' + record.codigoProdutoDefinicao + _ctx.props.chaveItens + index),
                          onFocus: ($event: any) => (_ctx.precoFoco(index)),
                          onBlur: _ctx.precoBlur,
                          onValorDigitado: ($event: any) => (_ctx.salvarItemGrade(index, record)),
                          onKeydown: [
                            _withKeys(_withModifiers(($event: any) => (_ctx.exibirDetalhesProduto(index)), ["shift","exact","prevent"]), ["d"]),
                            _withKeys(_withModifiers(($event: any) => (_ctx.editarItem(index)), ["shift","exact","prevent"]), ["e"]),
                            _withKeys(_withModifiers(($event: any) => (_ctx.excluirItem(index, $event)), ["shift","exact","prevent"]), ["delete"]),
                            _cache[13] || (_cache[13] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["tab"])),
                            _cache[14] || (_cache[14] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                            _cache[15] || (_cache[15] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent","shift"]), ["tab"])),
                            _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoEsquerda(record.emDigitacao, $event)), ["prevent"]), ["left"]),
                            _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoDireita(record.emDigitacao, $event)), ["prevent"]), ["right"]),
                            _withKeys(_withModifiers(($event: any) => (_ctx.elementoAbaixo($event, column.key)), ["prevent"]), ["down"]),
                            _withKeys(_withModifiers(($event: any) => (_ctx.elementoAcima($event, column.key)), ["prevent"]), ["up"])
                          ]
                        }, null, 8, ["dataAttributeColuna", "title", "valor", "onUpdate:valor", "emDigitacao", "onUpdate:emDigitacao", "disabled", "quantidadeCasasDecimais", "onFocus", "onBlur", "onValorDigitado", "onKeydown"]))
                      : (column.key === 'Icms')
                        ? (_openBlock(), _createBlock(_component_campo_numerico, {
                            key: 5,
                            classCss: "hidden ss-campo-numero-table",
                            classGroupCss: "hidden ss-campo-numero-table",
                            title: column.title,
                            dataAttributeColuna: column.key,
                            valor: record.impostos.icms.aliquotaIcms,
                            "onUpdate:valor": ($event: any) => ((record.impostos.icms.aliquotaIcms) = $event),
                            percentual: true,
                            disabled: true
                          }, null, 8, ["title", "dataAttributeColuna", "valor", "onUpdate:valor"]))
                        : (column.key === 'Ipi')
                          ? (_openBlock(), _createBlock(_component_campo_numerico, {
                              key: 6,
                              classCss: "hidden ss-campo-numero-table",
                              classGroupCss: "hidden ss-campo-numero-table",
                              title: column.title,
                              dataAttributeColuna: column.key,
                              valor: record.impostos.ipi.aliquotaIpi,
                              "onUpdate:valor": ($event: any) => ((record.impostos.ipi.aliquotaIpi) = $event),
                              percentual: true,
                              disabled: true
                            }, null, 8, ["title", "dataAttributeColuna", "valor", "onUpdate:valor"]))
                          : (column.key === 'Desconto')
                            ? (_openBlock(), _createBlock(_component_campo_numerico, {
                                key: 7,
                                title: column.title,
                                dataAttributeColuna: column.key,
                                valor: record.valorDesconto,
                                "onUpdate:valor": ($event: any) => ((record.valorDesconto) = $event),
                                emDigitacao: record.emDigitacao,
                                "onUpdate:emDigitacao": ($event: any) => ((record.emDigitacao) = $event),
                                monetario: true,
                                valorMaximo: 0,
                                classGroupCss: "hidden ss-campo-numero-table",
                                classCss: "hidden ss-campo-numero-table ss-nota-fiscal-eletronica-itens",
                                disabled: !_ctx.props.editavel,
                                onValorDigitado: ($event: any) => (_ctx.salvarItemGrade(index, record)),
                                onKeydown: [
                                  _withKeys(_withModifiers(($event: any) => (_ctx.exibirDetalhesProduto(index)), ["shift","exact","prevent"]), ["d"]),
                                  _withKeys(_withModifiers(($event: any) => (_ctx.editarItem(index)), ["shift","exact","prevent"]), ["e"]),
                                  _withKeys(_withModifiers(($event: any) => (_ctx.excluirItem(index, $event)), ["shift","exact","prevent"]), ["delete"]),
                                  _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoProximoElementoDesconto(record.emDigitacao, index, $event)), ["prevent","exact"]), ["tab"]),
                                  _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoProximoElementoDesconto(record.emDigitacao, index, $event)), ["prevent","exact"]), ["enter"]),
                                  _cache[16] || (_cache[16] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent","shift"]), ["tab"])),
                                  _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoEsquerda(record.emDigitacao, $event)), ["prevent"]), ["left"]),
                                  _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoDireita(record.emDigitacao, $event)), ["prevent"]), ["right"]),
                                  _withKeys(_withModifiers(($event: any) => (_ctx.elementoAbaixo($event, column.key)), ["prevent"]), ["down"]),
                                  _withKeys(_withModifiers(($event: any) => (_ctx.elementoAcima($event, column.key)), ["prevent"]), ["up"])
                                ]
                              }, null, 8, ["title", "dataAttributeColuna", "valor", "onUpdate:valor", "emDigitacao", "onUpdate:emDigitacao", "disabled", "onValorDigitado", "onKeydown"]))
                            : (column.key === 'Total')
                              ? (_openBlock(), _createBlock(_component_campo_numerico, {
                                  key: 8,
                                  title: column.title,
                                  dataAttributeColuna: column.key,
                                  valor: record.valorTotal,
                                  monetario: true,
                                  disabled: true,
                                  classGroupCss: "hidden ss-campo-numero-table",
                                  classCss: "hidden ss-campo-numero-table"
                                }, null, 8, ["title", "dataAttributeColuna", "valor"]))
                              : (column.key === 'Item')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createElementVNode("span", null, [
                                      _createElementVNode("a", {
                                        onClick: ($event: any) => (_ctx.editarItem(index))
                                      }, [
                                        _createElementVNode("span", null, _toDisplayString(record.descricao), 1)
                                      ], 8, _hoisted_13)
                                    ]),
                                    _createElementVNode("span", null, "Quantidade: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.quantidade,
                      record.casasDecimaisUnidade)) + "(" + _toDisplayString(record.siglaUnidade) + ") ", 1),
                                    _createElementVNode("span", null, "Vlr Unitário: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.precoUnitario,
                      record.casasDecimaisPrecoUnitario, true)), 1),
                                    _createElementVNode("span", null, "Desconto: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.valorDesconto, 2, true)), 1),
                                    _createElementVNode("span", null, "Total: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.valorTotal, 2, true)), 1),
                                    _createElementVNode("div", _hoisted_14, [
                                      _createElementVNode("a", {
                                        class: "visualizar",
                                        onClick: ($event: any) => (_ctx.editarItem(index))
                                      }, [
                                        _createVNode(_component_icone, { nome: "editar" })
                                      ], 8, _hoisted_15),
                                      (_ctx.props.editavel)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            class: "excluir",
                                            onClick: ($event: any) => (_ctx.excluirItem(index))
                                          }, [
                                            _createVNode(_component_icone, { nome: "excluir" })
                                          ], 8, _hoisted_16))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["loading", "columns", "data-source"]))
      ])
    ]),
    _createVNode(_component_nota_fiscal_item_modal, {
      visivel: _ctx.state.exibirDetalhesItem,
      "onUpdate:visivel": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.exibirDetalhesItem) = $event)),
      empresa: _ctx.dadosEmpresa.codigoEmpresa,
      pessoa: 0,
      dadosPessoaMovimento: _ctx.props.dadosPessoaMovimento,
      totalNota: _ctx.props.totalNotaFiscal,
      item: _ctx.state.itemSelecionado,
      existeAnterior: _ctx.state.existeAnterior,
      existeProximo: _ctx.state.existeProximo,
      editavel: _ctx.props.editavel,
      atualizarApenasInformacoesFiscais: _ctx.props.atualizarApenasInformacoesFiscais,
      tipoOperacao: _ctx.props.tipoOperacao,
      incidencias: _ctx.props.incidencias,
      estoquesDisponiveis: [],
      atualizarValores: _ctx.props.atualizarValores,
      onSalvar: _ctx.salvarItem,
      onProximoItem: _ctx.proximoItem,
      onItemAnterior: _ctx.itemAnterior
    }, null, 8, ["visivel", "empresa", "dadosPessoaMovimento", "totalNota", "item", "existeAnterior", "existeProximo", "editavel", "atualizarApenasInformacoesFiscais", "tipoOperacao", "incidencias", "atualizarValores", "onSalvar", "onProximoItem", "onItemAnterior"]),
    _createVNode(_component_detalhes_produto_modal, {
      visivel: _ctx.state.exibirDetalhesProduto,
      "onUpdate:visivel": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.exibirDetalhesProduto) = $event)),
      empresa: _ctx.dadosEmpresa.codigoEmpresa,
      definicaoProduto: _ctx.state.codigoDefinicaoSelecionada
    }, null, 8, ["visivel", "empresa", "definicaoProduto"])
  ]))
}